module.exports = __webpack_public_path__ + "img/polykondensation.988ae229.gif";